import { ListItemModel, updateListItemModel, updateListItemStatus } from "./ListItemModel";

export function ItemsModel() {
    const list = [];

    function add(newItems) {
        newItems.forEach((item) => {
            list.push(ListItemModel(item));
        });
    }

    function reset() {
        list.length = 0;
    }

    function update(itemId, itemData) {
        itemId = itemId.toString();
        const item = list.find((i) => i.id.toString() === itemId);
        if (item) updateListItemModel(item, itemData);
    }

    function updateStatus(itemId, itemData) {
        itemId = itemId.toString();
        const item = list.find((i) => i.id.toString() === itemId);
        if (item) updateListItemStatus(item, itemData);
    }

    return {
        list,
        add,
        reset,
        update,
        updateStatus,
    };
}
